import { Branding, Link } from "@bcm-dev/bcms-vite";
import { WidgetContainer } from "components/shared";
import React from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function WirePayeeConfirmationWidget
 * @param {STRING} wirePayee - Sets the wire payee name text.
 * @param {STRING} wireAmount - Sets the wire amount text.
 * @param {STRING} wireDate -Sets the wire date text.
 * @return {React.Component}
 * @exported true
 * @description This is Wire Payee Confirmation widget for OneTimeWirePage
 */
export default function WirePayeeConfirmationWidget(props) {
    const data = props.data ?? {};
    const action = props.action ?? {};
    const createdOneTimeWireTransfer = data.createdOneTimeWireTransfer ?? {};
    const wirePayee = props.wirePayee ?? "[wirePayee]";
    const wireAmount = props.wireAmount ?? "[wireAmount]";
    const wireDate = props.wireDate ?? "[wireDate]";

    return (
        <WidgetContainer className="wire-payee-confirmation-widget">
            <div className="flex-container flex-horizontal align-center confirmation-success-container">
                <div className="flex-width flex-container align-center success-message">
                    <SVGAsset id="CircleCheckmarkIcon" className="circle-checkmark-icon" />
                    <span className="success-message-text" data-point="Wire_Success_Text">Wire Successfully Initiated</span>
                </div>
                <div className="set-width ">
                    <SVGAsset id="CloseX" className="close-x-icon clickable" onClick={ action.onSubmittedConfirmationClose } />
                </div>
            </div>
            <div className="confirmation-content-container">
                <Branding id="wire_approvals_abi22" value="true" default="false">
                    <p className="wire-scheduled-text"><span data-point="Wire_Scheduled_Text">Your wire has been scheduled and is awaiting approval(s).</span></p>
                </Branding>
                <div className="confirmation-info-container">
                    <div className="flex-container flex-horizontal align-center reference-number-info">
                        <div className="flex-width info-label text-center">
                            <span>Reference Number:</span>
                        </div>
                        <div className="flex-width info-text">
                            <span>{ createdOneTimeWireTransfer.referenceNumber }</span>
                        </div>
                    </div>
                    <div className="flex-container flex-horizontal align-center payee-info">
                        <div className="flex-width info-label text-center">
                            <span>Payee:</span>
                        </div>
                        <div className="flex-width info-text">
                            <span>{ createdOneTimeWireTransfer.name }</span>
                        </div>
                    </div>
                    <div className="flex-container flex-horizontal align-center funding-account">
                        <div className="flex-width info-label text-center">
                            <span>Funding Account:</span>
                        </div>
                        <div className="flex-width info-text">
                            <span>{ createdOneTimeWireTransfer.fundingAccount.number }</span>
                        </div>
                    </div>
                    <div className="flex-container flex-horizontal align-center amount-info">
                        <div className="flex-width info-label text-center">
                            <span>Amount:</span>
                        </div>
                        <div className="flex-width info-text">
                            <span>{ createdOneTimeWireTransfer.amount.format() }</span>
                        </div>
                    </div>
                    <div className="flex-container flex-horizontal align-center wire-date-info">
                        <div className="flex-width info-label text-center">
                            <span>Wire Date:</span>
                        </div>
                        <div className="flex-width info-text">
                            <span>{ createdOneTimeWireTransfer.date.format("m/d/Y") }</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="confirmation-link-container flex-container flex-horizontal">
                <Link className="initiate-wire-link show-on-mobile" onClick={ action.onSubmittedConfirmationClose }><span>Initiate Another Wire</span></Link>
                <Link className="wire-activity-link" to="/wiresActivity"><span data-point="See_Wire_Activity_Link">See Wire Activity</span></Link>
            </div>
        </WidgetContainer>
    )
}
